import React, { useEffect } from "react"
import { AuthContext, AuthStatus, IAuth } from "components/authentication/context/authContext"
import { useContext } from "react"

export const AuthCheck = ({ status, children }: { status: AuthStatus, children?: React.ReactNode }) => {
  const { authStatus }: IAuth = useContext(AuthContext)
  return authStatus === status ? <>{children}</> : null
}